import { guessTimezone } from '@/src/general/primitives/dates/dayjs'
import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { DONATION_SOURCE, TDonationData } from './types/donation'

export const donationApi = {
  getDonationBanner: ({ signal, cacheBuster }: TSignalConfig & { cacheBuster?: string }) =>
    fetcher.query<TDonationData>('/donation-banner', {
      signal,
      params: { tz: guessTimezone(), ...(cacheBuster ? { cacheBuster } : {}) },
    }),
  setDonateLaterReminder: (payload?: { source?: DONATION_SOURCE; campaign?: string }) =>
    fetcher.mutate<void, { source?: DONATION_SOURCE; campaign?: string } | undefined>(
      '/donate-later/reminder',
      payload,
      {
        method: 'POST',
      },
    ),
  setDonationBannerDisplayed: (payload: { source?: DONATION_SOURCE }) =>
    fetcher.mutate('/banner-displayed', payload, { method: 'PATCH' }),
}
